// Map a resource's stored unit code (backend `MeasurementUnits`, see
// api/users/models/user_resources.py) to chart display metadata: the value-axis
// title prefix, the unit suffix, and how many decimals to show for values.
// Power resources keep the historical "Average Power (MW)" wording; price
// resources (EUR/MWh) read as "Price (EUR/MWh)".

const UNIT_META = {
  w: { label: 'Average Power', unit: 'W', decimals: 0 },
  kw: { label: 'Average Power', unit: 'kW', decimals: 0 },
  mw: { label: 'Average Power', unit: 'MW', decimals: 0 },
  mwh: { label: 'Energy', unit: 'MWh', decimals: 1 },
  eur_mwh: { label: 'Price', unit: 'EUR/MWh', decimals: 2 },
};

const DEFAULT_META = UNIT_META.mw;

// Resolve display metadata for a unit code, falling back to MW for unknown or
// missing values so existing power resources are unaffected.
export const resourceUnitMeta = (units) =>
  UNIT_META[(units || '').toLowerCase()] || DEFAULT_META;

// Full value-axis title, e.g. "Price (EUR/MWh)" or "Average Power (MW)".
export const valueAxisLabel = (units) => {
  const { label, unit } = resourceUnitMeta(units);
  return `${label} (${unit})`;
};

// Format a numeric value with its unit for tooltips, e.g. "130.60 EUR/MWh".
export const formatValueWithUnit = (value, units) => {
  if (value == null) return '–';
  const { unit, decimals } = resourceUnitMeta(units);
  return `${Number(value).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} ${unit}`;
};
